import { HttpClient, HttpParams } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, inject, input, signal } from '@angular/core';
import { SecurityService } from 'app/core/security/security.service';
import { SystemMessage } from 'app/core/system-message/system-message-service';
import { RxSearchVm } from 'app/shared/generated/Administration/Models/Users/RxSearchVm';
import { UserJsVm } from 'app/shared/generated/Administration/Models/Users/UserJsVm';
import { QuickUserInfoService } from 'app/shared/quick-user-info/quick-user-info.service';
import { ResizableWidgetComponent } from '../resizable-widget/resizable-widget.component';
import { LinkComponent } from 'app/shared/link/link.component';

@Component({
    selector: 'pcg-rx-search-widget',
    templateUrl: './rx-search-widget.html',
    styleUrls: ['../resizable-refill-request/resizable-refill-request.scss',
        '../resizable-widget/resizable-widget.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        LinkComponent,
        ResizableWidgetComponent
    ]
})
export class RxSearchWidget {
    readonly infoService = inject(QuickUserInfoService);
    private readonly http = inject(HttpClient);
    private readonly sec = inject(SecurityService);
    private readonly cdr = inject(ChangeDetectorRef);

    readonly isSearching = signal(false);
    readonly orders = signal<RxSearchVm[]>([]);
    readonly noOrdersText = signal('No Orders');
    readonly user = signal<UserJsVm | null>(null);
    readonly isUser = computed(() => this.user()?.isRxUser);

    ngOnInit() { this.initialize(); }

    searchRx(rxNumber: string): void {
        this.isSearching.set(true);
        const params = new HttpParams()
            .set('rxNumber', rxNumber)
            .set('facilityId', this.infoService.userFacilityId());

        this.http.get<SystemMessage>('api/Admin/Widgets/SearchRxNumber', { params }).subscribe({
            next: (msg) => {
                this.orders.set(msg.model);
                this.isSearching.set(false);
                if (msg.model.length === 0) { this.noOrdersText.set('No Orders Found'); }
                this.cdr.markForCheck();
            },
            error: (error) => {
                console.error('Error searching Rx:', error);
                this.isSearching.set(false);
                this.cdr.markForCheck();
            },
        });
    }

    redirect(order: RxSearchVm) {
        return `pharmacy/inventories/fulfillment/edit/${order.refillId}/${order.inventoryId}`;
    }

    private initialize(): void {
        this.user.set(this.sec.getUser());
    }
}
